import { MobilePositionParamSwitchStyled } from "./styled/MobilePositionParamSwitchStyled";
import { Form } from "react-bootstrap";
import React from "react";

function MobilePositionParamSwitch(props) {
    const {label, checked, onChange} = props;
    return <MobilePositionParamSwitchStyled>
        <Form.Check type="switch">
            <Form.Label role="button">{label}</Form.Label>
            <Form.Check.Input checked={checked} onChange={onChange}/>
        </Form.Check>
    </MobilePositionParamSwitchStyled>
}

export default MobilePositionParamSwitch;
